import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Container, Grid, Typography, Paper } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import * as Inputs from "../../components/Common/Inputs";
const useStyles = makeStyles((theme) => ({
  root: {
    // position: "relative",
    marginTop: theme.spacing(2),
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    // // backgroundColor: theme.palette.primary.light,
    // [theme.breakpoints.down("md")]: {
    //   backgroundColor: "white",
    // },
  },

  gridContainer: {
    flex: 6,
  },
  searchBtn: {
    height: theme.spacing(7),
    flex: 1,
    borderRadius: 100,
    borderRadius: 100,
  },
  Container: {
    // height: "30vh",

    // zIndex: 99999,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    width: "100%",
    padding: theme.spacing(2),
    borderRadius: 100,
    boxShadow: "0px 5px 10px rgba(0,0,0,0.1)",
    // backgroundColor: theme.palette.primary.dark,
  },
  title: {
    fontSize: 45,
    // color:'white'
    fontWeight: 600,
    textAlign: "center",
    color: theme.palette.secondary.main,
  },
  gridItem: {
    paddingRight: theme.spacing(2),
    borderRight: `2px solid #cacaca`,
    // borderStyle: "solid",
  },
}));

const SearchComponent = ({ data }) => {
  const classes = useStyles();
  const { handleSubmit, control, reset } = useForm();
  const onSubmit = (data) => console.log("search data", data);

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        <Paper className={classes.Container} elevation={0}>
          <Grid
            container
            alignItems="center"
            justify="space-evenly"
            className={classes.gridContainer}
          >
            {data?.data?.map((item, index) => {
              const MyInput = Inputs[item.type];
              item.classes = {
                select: {
                  backgroundColor: "red",
                },
              };
              return (
                <Grid item lg={3} className={classes.gridItem}>
                  <Controller
                    name={item.name}
                    control={control}
                    defaultValue={undefined}
                    render={(props) => (
                      <MyInput
                        {...props}
                        {...item}

                        // onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )} // props contains: onChange, onBlur and value
                  />
                </Grid>
              );
            })}
          </Grid>
          {data && (
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              type="submit"
              disableElevation
              className={classes.searchBtn}
            >
              Search
            </Button>
          )}
        </Paper>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        {/* <Container className={classes.container} maxWidth="lg"> */}
        {/* <Grid
            container
            alignItems="center"
            justify="center"
            className={classes.gridContainer}
          >
            <Grid item lg={12}>
              <Typography className={classes.title}>
                તમારું ગ્રામ શોધો
              </Typography>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              justify="space-between"
              lg={12}
              md={12}
              sm={12}
              xs={12}
            >
              {data?.data?.map((item, index) => {
                const MyInput = Inputs[item.type];
                item.classes = {
                  select: {
                    backgroundColor: "red",
                  },
                };
                return (
                  <Grid item lg={3}>
                    <Controller
                      name={item.name}
                      control={control}
                      defaultValue={undefined}
                      rules={{ required: false }}
                      render={(props) => (
                        <MyInput
                          {...props}
                          {...item}

                          // onChange={(e) => props.onChange(e.target.checked)}
                        />
                      )} // props contains: onChange, onBlur and value
                    />
                  </Grid>
                );
              })}
              <Grid item lg={2}>
                {data && (
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    type="submit"
                    disableElevation
                    className={classes.searchBtn}
                  >
                    Search
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid> */}
      </Container>
      {/* </form> */}
    </div>
  );
};
export default SearchComponent;
